import chatGPT from "src/modules/chatGPT/chatGPTReducers";
import importerReducer from "src/modules/prompt/importer/promptImporterReducers";
import { combineReducers } from "redux";

export default combineReducers({
  chatGPT,
  importer: importerReducer,
});
